import axios from '@shared/axios-shared';

const getfinance = (paid, school, date_from, date_to, export_data, page) => {
	return axios.get(
		`/api/v1/owner/stripe/transactions?status=${paid}&school_name=${school}&date_from=${date_from}&date_to=${date_to}&export_data=${export_data}&page=${page}`
	);
};

export { getfinance };
